"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactFinalFormArrays = require("react-final-form-arrays");
const useKiwtFieldArray = function (name) {
  let submitWholeDeletedObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const {
    fields
  } = (0, _reactFinalFormArrays.useFieldArray)(name);
  const {
    value: values = []
  } = fields;
  const [endOfList, setEndOfList] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    const i = values.filter(line => !line._delete);
    setEndOfList(i.length);
  }, [values]);
  const onAddField = function () {
    let field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      _delete: false
    };
    fields.insert(endOfList, field);
  };
  const onMarkForDeletion = field => {
    if (field && field.id) {
      if (submitWholeDeletedObject) {
        fields.push({
          ...field,
          _delete: true
        });
      } else {
        fields.push({
          id: field.id,
          _delete: true
        });
      }
    }
  };
  const onDeleteField = (index, field) => {
    fields.remove(index);
    onMarkForDeletion(field);
  };
  const onPrependField = function () {
    let field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      _delete: false
    };
    fields.unshift(field);
  };
  const onReplaceField = (index, field) => {
    if (fields.update) {
      // react-final-form-arrays
      fields.update(index, field);
    }
  };
  const onUpdateField = (index, field) => {
    fields.update(index, {
      ...fields.value[index],
      ...field
    });
  };
  const items = values.slice(0, endOfList);
  return {
    items,
    onAddField,
    onDeleteField,
    onMarkForDeletion,
    onPrependField,
    onReplaceField,
    onUpdateField
  };
};
var _default = exports.default = useKiwtFieldArray;